import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, SHORT_ATM} from "../MarginQuizQuestions";

export const AtTheMoney = "tfAtTheMoneyCall";

export function atTheMoney() {
    return {
        templateUrl: "app/quiz/margin/questions/ShortAtTheMoneyCall.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: ShortAtTheMoneyCallController
    };
}

export class ShortAtTheMoneyCallController extends MarginQuizQuestionController {
    public config = SHORT_ATM;
}
